import { Consultation, ConsultationResponseAnswer } from '../../../../types';

/**
 * The function `canSubmitAnswers` checks if a consultation response can be submitted based on various
 * conditions.
 * @param {boolean} isRespondedStatus - A boolean value indicating whether the consultation has already
 * been responded to.
 * @param {Consultation} consultation - The `consultation` parameter is an object that represents a
 * consultation. It likely contains information such as the consultation ID, the questions asked, and
 * any other relevant details.
 * @param {boolean} canSubmitIfLateResponse - A boolean value indicating whether the submission can be
 * made even if the response is late.
 * @param {ConsultationResponseAnswer[]} answers - An array of ConsultationResponseAnswer objects,
 * which represent the answers provided by the user for each question in the consultation.
 * @returns a boolean value.
 */
export const canSubmitAnswers = (
  isRespondedStatus: boolean,
  consultation: Consultation,
  canSubmitIfLateResponse: boolean,
  answers: ConsultationResponseAnswer[]
): boolean => {
  const allAnswersApproved =
    consultation.questions.length === answers.length &&
    answers.every((answer) => answer.approved);

  return canSubmitIfLateResponse && allAnswersApproved && !isRespondedStatus;
};
